import Auth from '@aws-amplify/auth';
import { isMobile } from 'react-device-detect';
import { store } from 'core';

import { resetStoreAction } from 'core/actions';
import { routePaths } from 'modules/auth/constants';

type LogoutOptions = {
  redirect?: boolean;
};

const AUTHENTICATOR_AUTH_STATE_KEY = 'amplify-authenticator-authState';

let logoutPromise: Promise<void> | null = null;

const performLogout = async ({ redirect = true }: LogoutOptions) => {
  try {
    await Auth.signOut();
  } catch (error) {
    console.warn('Unable to complete Cognito sign out.', error);
  }

  store.dispatch(resetStoreAction());

  try {
    window.localStorage.removeItem(AUTHENTICATOR_AUTH_STATE_KEY);
  } catch (error) {
    console.warn('Unable to clear the authentication state.', error);
  }

  if (!redirect) {
    return;
  }

  const path = isMobile ? `${routePaths.root}?webview=mobile&authPage=signin` : routePaths.root;
  window.location.href = path;
};

export const logout = (options: LogoutOptions = {}): Promise<void> => {
  if (!logoutPromise) {
    logoutPromise = performLogout(options).finally(() => {
      logoutPromise = null;
    });
  }

  return logoutPromise;
};
